import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import './InfoNotification.css';
import apiClient from "../../../axios";
import SuccessProcess from '../SuccessProcess';

const InfoNotification = ({ message, isVisible, onClose, payload, route }) => {
    const navigate = useNavigate();
    const [successVisible, setSuccessVisible] = useState(false);
    const [message2, setMessage2] = useState('');
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose(); // Oculta la notificación después de 4 segundos
            }, 4000);

            // Limpia el temporizador si el componente se desmonta o si isVisible cambia
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);
    const handleConfirm = async () => {
        try {
            const response = await apiClient.post(route, payload);
            //console.log(response.data.message);
            if (response.data.message.endsWith('Restored Successfully')) {
                setSuccessVisible(true);
                setMessage2('Se ha restaurado la información exitosamente');
                navigate(-1);
            } else if (response.data.error === 'Bad Request') {
                setSuccessVisible(true);
                setMessage2(response.data.message);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleCloseSuccess = () => {
        setSuccessVisible(false);
        onClose(); // Close the InfoNotification as well
    };

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info">
                    <div className="icon-container-noti-info">
                        <FontAwesomeIcon icon={faCircleInfo} className="icon-noti2" />
                    </div>
                    <div className="message-container-info">
                        <h4>Información</h4>
                        <p>{message}</p>
                    </div>
                    <div className="button-container-info">
                        <button className="cancel-btn-info" onClick={onClose}>
                            Cancelar
                        </button>
                        <button className="ok-btn-info" onClick={handleConfirm}>
                            OK
                        </button>
                    </div>
                    <SuccessProcess
                        message={message2}
                        isVisible={successVisible}
                        onClose={handleCloseSuccess}
                        redirectOnOk = {false}
                        whatsApp={false} 
                    />
                </div>
            </div>
        )
    );
};

export default InfoNotification;
